/**
 * TCR-1326 I2 — CK tích luỹ đã đặt phải kẹp lại khi trần (tiền hàng còn lại sau
 * voucher/KM) giảm. Trả số mới CHỈ khi `trade` lớn hơn hẳn trần; ngược lại
 * `null` (không đụng form → không vòng lặp render).
 */
export function clampTradeDiscount(trade: number, cap: number): number | null {
  const safeCap = Math.max(0, Number.isFinite(cap) ? cap : 0);
  return trade > safeCap ? safeCap : null;
}
